<template>
	<NavigationMenu class="h-full" viewport-class="bg-primary">
		<slot name="logo" />
		<NavigationMenuList class="h-full" orientation="horizontal">
			<NavigationMenuItem class="h-full">
				<NavigationMenuTrigger
					v-model:mouse-over="navOptionsController.buy"
					class="h-full text-base font-normal leading-[24px] tracking-wide"
					:is-nav-option-open="navOptionsController.buy ? true : undefined"
					@click="trackHeader.handleEventHeaderClick('Comprar')"
				>
					Comprar
				</NavigationMenuTrigger>
				<NavigationMenuContent
					v-model:mouse-over="navOptionsController.buy"
					class="h-full"
				>
					<ul
						class="grid min-h-[359px] md:w-[400px]"
						:class="[
							selectedCity
								? 'grid-cols-3 lg:w-[747px] xl:w-[1077px]'
								: 'grid-cols-2 lg:w-[498px] xl:w-[715px]'
						]"
					>
						<li class="row-span-3 border-r border-primary-light-4 px-6 py-8">
							<PortalHeaderNavSectionDefault
								:nav-options="highlightBuyOptions"
								as-child
							/>
						</li>

						<li
							class="row-span-3 border-r border-primary-light-4 py-8 pl-[32px]"
						>
							<PortalHeaderNavSectionCities
								v-model:selected-city="selectedCity"
								:cities="cities"
								as-child
							/>
						</li>
						<li v-if="selectedCity" class="row-span-3 bg-primary-light-4 p-8">
							<PortalHeaderNavSectionCityRegion
								v-model:selected-city="selectedCity"
								as-child
							/>
						</li>
					</ul>
				</NavigationMenuContent>
			</NavigationMenuItem>
			<NavigationMenuItem class="h-full">
				<NavigationMenuTrigger
					v-model:mouse-over="navOptionsController.sell"
					class="h-full text-base font-normal leading-[24px] tracking-wide"
					:is-nav-option-open="navOptionsController.sell ? true : undefined"
					@click="trackHeader.handleEventHeaderClick('Vender')"
				>
					Vender
				</NavigationMenuTrigger>
				<NavigationMenuContent
					v-model:mouse-over="navOptionsController.sell"
					class="h-full"
				>
					<ul class="grid min-h-[208px] w-[360px]">
						<li class="row-span-3 border-r border-primary-light-4 px-6 py-8">
							<PortalHeaderNavSectionDefault
								:nav-options="sellOptions"
								as-child
							/>
						</li>
					</ul>
				</NavigationMenuContent>
			</NavigationMenuItem>
		</NavigationMenuList>
	</NavigationMenu>
</template>

<script setup lang="ts">
import {
	NavigationMenu,
	NavigationMenuContent,
	NavigationMenuItem,
	NavigationMenuList,
	NavigationMenuTrigger
} from '@/components/ui/navigation-menu';
import { type City, highlightBuyOptions, sellOptions, cities } from '.';
import { useEvents } from '~/composables/events/useEvents';
const { trackHeader } = useEvents();

defineOptions({
	// TODO: Escobar falou que adicionu esse inheritAttrs: false porque estava dando warning no console. mas acabou quebrando o funcionamento do menu. Então estou comentando ele por enquanto.
	// inheritAttrs: false
});

type NavOptionsController = {
	sell: boolean;
	buy: boolean;
};
const navOptionsController = ref<NavOptionsController>({
	sell: false,
	buy: false
});

const selectedCity = ref<City | null>(cities[0] ?? null);

watch(
	() => navOptionsController.value.buy,
	value => {
		if (!value) {
			selectedCity.value = cities[0] ?? null;
		}
	}
);
</script>
